import {
    ButtonGradientPrimary,
    Colors,
    Icon,
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@amelio/ui-library';

import type { IconProps } from '@amelio/ui-library';
import type { MouseEvent, ReactNode } from 'react';

interface EvaluationStartButtonProps {
    canStartEvaluations?: boolean;
    disabled?: boolean;
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
    tooltip: string;
    /** The white glyph before the label; a name from the library's registry. */
    iconName?: IconProps['name'];
    children?: ReactNode;
}

export const EvaluationStartButton = ({
    canStartEvaluations = true,
    disabled = false,
    onClick,
    tooltip,
    iconName,
    children,
}: EvaluationStartButtonProps) => {
    const isDisabled = disabled || !canStartEvaluations;

    const button = (
        <ButtonGradientPrimary
            // About 36px tall from its padding: the 21px line of size md plus py-2 above and below.
            size={'md'}
            // The panels stack their content in a column: without `self-start` the button stretches
            // to the panel's width, `fitContent` alone does not stop that.
            className={`h-auto self-start py-2 ${canStartEvaluations ? '' : 'pointer-events-none'}`}
            disabled={isDisabled}
            onClick={onClick}
            leftIcon={
                iconName && (
                    <Icon
                        name={iconName}
                        color={Colors.WHITE}
                        size={16}
                        ariaHidden
                    />
                )
            }
        >
            {children}
        </ButtonGradientPrimary>
    );

    if (canStartEvaluations) {
        return button;
    }

    return (
        <TooltipProvider>
            <Tooltip delayDuration={200}>
                <TooltipTrigger asChild>
                    <span className={'inline-block cursor-not-allowed self-start'}>{button}</span>
                </TooltipTrigger>
                <TooltipContent side={'top'}>
                    <p>{tooltip}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
